<div [formGroup]="campaignDraft.campaignForm">
  <label class="form-label">
    <strong>{{ 'campaign.smoothing.title' | translate }}</strong>
  </label>
  <div class="form-check">
    <input class="form-check-input" type="radio" name="deliveryCurve" id="smoothRadioInput" formControlName="deliveryCurve" [value]="'EVEN'"/>
    <label class="form-check-label" for="smoothRadioInput" [innerHTML]="'campaign.smoothing.trueField' + (suffix || '') | translate"></label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio" name="deliveryCurve" id="fastRadioInput" formControlName="deliveryCurve" [value]="'FAST_AS_POSSIBLE'"/>
    <label class="form-check-label" for="fastRadioInput" [innerHTML]="'campaign.smoothing.falseField' + (suffix || '') | translate"></label>
  </div>
</div>
